function checkLegacyPattern(
  name: string,
  selector: string,
  dataGetter?: (elem: Element) => unknown,
): void {
  const elements = document.querySelectorAll(selector);
  const { stack } = Error("");
  const pagecluster = window.o_util.misc.getPagecluster();

  const data = dataGetter ? Array.from(elements).map(dataGetter) : undefined;

  if (elements.length > 0) {
    window.AS.RUM.sendCustomRequest("assets-legacy-pattern", {
      name,
      pagecluster,
      count: elements.length,
      stack,
      data,
    });
  }
}

/*                                                            */
function logLegacyWarnings(): void {
  /*                         */

  checkLegacyPattern("linie", ".p_line100, .p_line200");
}

export { logLegacyWarnings };
